import { AxiosRequestConfig } from "axios";

import { SubmissionL, Submission } from "../../type";
import { ResponseT } from "@utils/api/base";
import { Submissions } from "@utils/api";
import { handleError } from "@utils/misc";
import useCognito from "@as_core/account/useCognito";

const useSubmissions = () => {
  const { getToken } = useCognito();

  const getSubmissions = async (params): Promise<ResponseT<SubmissionL>> => {
    const token = getToken();
    const config: AxiosRequestConfig = { params };
    let resp;

    try {
      resp = await Submissions.all(token, config);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  const getSubmissionsFinite = async (params, data) => {
    const token = getToken();
    const config: AxiosRequestConfig = { params };
    let resp;

    try {
      resp = await Submissions.list(token, data, config);
    } catch (err) {
      handleError(err);
      return null;
    }

    if (resp.data.errors.length > 0) {
      //DHR fix later console.log('getCompoundsFinite ERRORS', resp.data.errors);
    }

    return resp.data;
  };

  const getSubmission = async (submissionId, params = null): Promise<ResponseT<Submission>> => {
    const token = getToken();
    const config: AxiosRequestConfig = { params };
    let resp;

    try {
      resp = await Submissions.get(token, submissionId, config);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  const addSubmission = async (submissionData) => {
    const token = getToken();
    let resp;

    try {
      resp = await Submissions.add(token, submissionData);
    } catch (err) {
      handleError(err);
      return null;
    }

    return resp.data;
  };

  return {
    getSubmissions,
    getSubmissionsFinite,
    getSubmission,
    addSubmission,
  };
};

export default useSubmissions;
